export default {

    getVendorSettings: (data) => window.axios.get('web-settings', { params: data }),
    getGoogleAnalytics: (data) => window.axios.get(`analytics/trackingID?order_web=${data.host}`, data),
    CheckMobileNumber: (data) => window.axios.post('customer/verify-email-mobile', data),
    CheckLogin: (data) => window.axios.post('customer/login', data),
    customerForgotPassword: (data) => window.axios.post('customer/password/forgot', data),
    forgotPasswordVerifyOtp: (data) => window.axios.post('customer/otp/verify', data),
    customerChangePassword: (data) => window.axios.post('customer/password/reset', data),
    getMessageList: (data) => window.axios.get(`chat/message?another_user_id=${data.another_user_id}&login_user_id=${data.login_user_id}&skip=${data.skip}&type=${data.type}&total_record=${data.total_record}`),
    postSendMessage: (data) => window.axios.post('chat/message', data),





    getUserDetails: (data) => window.axios.post('get_user_details_web', data),
    // customerChangePassword: (data) => window.axios.post('customer_change_password', data),
    loginGooglefacebook: (data) => window.axios.post('facebook_login', data),
    getLanguageSettings: (data) => window.axios.get('get-language?order_web=' + data),



    CheckThirdPartyOtp: (data) => window.axios.post('customer/check-third-party-forgot-password-otp', data),
    VerifyThirdPartyOtp: (data) => window.axios.post('customer/verify-third-party-otp', data),


}